import React from "react";

const LoadingPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "2rem",
        background: "#222",
        color: "#fff",
      }}
    >
      Loading...
    </div>
  );
};

export default LoadingPage;
